export const MENU_LINKS = [{
        id: "appointments",
        name: "Appointments",
        path: "appointments",
    },
    {
        id: "patients",
        name: "Patients",
        path: "patients",
    },
    {
        id: "conciergeService",
        name: "Concierge Service",
        path: "concierge-service",
    },
    {
        id: "notifications",
        name: "Notifications",
        path: "notifications",
    },
    {
        id: "availability_schedule",
        name: "Availability Schedule",
        path: "availability-schedule",
    },
    {
        id: "earning_reports",
        name: "Earning Reports",
        path: "earning-reports",
    },
    {
        id: "note_templates",
        name: "Note Templates",
        path: "note-templates",
    },
    {
        id: "settings",
        name: "Settings",
        path: "settings",
    },
];
export const SETTING_LINKS = [
    { name: "Payments", path: "payment-history" },
    { name: "Nudge permission", path: "nudge-permission" },
    { name: "Concierge Service", path: "concierge-service-settings" },
    { name: "Blocked patients", path: "blocked-patients" },
    { name: "Change location", path: "change-location" },
    { name: "About Us", path: "about-us" },
    { name: "contact us", path: "contact-us" },
];